import { Text } from "@amzn/storm-ui";
import type { ReactElement } from "react";

import SkeletonLoader from "../../common/SkeletonLoader";
import { ComponentLabel } from "../../common/styled.components";

interface ContextItemProps {
    isLoading: boolean;
    label: string;
    value: string | undefined;
}

export const ContextItem = ({
    isLoading,
    label,
    value,
}: ContextItemProps): ReactElement | null => {
    return isLoading ? (
        <SkeletonLoader height="15px" width="100px" />
    ) : value ? (
        <Text>
            <ComponentLabel>{label}: </ComponentLabel>
            {value}
        </Text>
    ) : null;
};
